module.exports = __webpack_public_path__ + "static/beauty-sima-salon-section-3ebdfe33c12dbda65918e6ddd8b32004.png";